exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".about-container[data-v-45531246] {\n  padding-bottom: 122px !important;\n}", ""]);

// exports
